import { render, staticRenderFns } from "./largerSiderPage.vue?vue&type=template&id=08e51897"
import script from "./largerSiderPage.vue?vue&type=script&lang=js"
export * from "./largerSiderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports